import {
    getNewBetHands,
    HandSeats,
} from '@/models/games/blackjack2/SeatCardInfo';
import { EntityState, PayloadAction } from '@reduxjs/toolkit';
import { bj2HandsAdapter } from './handSlice';
import { UpdateHandsInfoPayload } from './payload';

const reset = (
    state: EntityState<HandSeats, number>,
    action: PayloadAction<number>
) => {
    bj2HandsAdapter.updateOne(state, {
        id: action.payload,
        changes: getNewBetHands(action.payload),
    });
};
const updateHands = (
    state: EntityState<HandSeats, number>,
    action: PayloadAction<UpdateHandsInfoPayload>
) => {
    const hostId = action.payload.hostId;
    const host = state.entities[hostId];

    if (host) {
        bj2HandsAdapter.updateOne(state, {
            id: action.payload.hostId,
            changes: {
                ...action.payload.infos,
            },
        });
    }
};
const updateCardsOnly = (
    state: EntityState<HandSeats, number>,
    action: PayloadAction<UpdateHandsInfoPayload>
) => {
    const hostId = action.payload.hostId;
    const host = state.entities[hostId];
    if (host) {
        bj2HandsAdapter.updateOne(state, {
            id: action.payload.hostId,
            changes: {
                Dealer: action.payload.infos.Dealer,
                Seat1: action.payload.infos.Seat1,
                Seat2: action.payload.infos.Seat2,
                Seat3: action.payload.infos.Seat3,
                Seat4: action.payload.infos.Seat4,
                Seat5: action.payload.infos.Seat5,
                Seat6: action.payload.infos.Seat6,
                Seat7: action.payload.infos.Seat7,
            },
        });
    }
};
export const bj2HandsReducer = {
    reset,
    updateHands,
    updateCardsOnly,
};
